// Generated by genversion.
export const version = '3.6.0';
